import './Login.scss'
import { useEffect, useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../../../firebase';
import { login } from "../../auth-slice"
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../shared/store';
import { TextField, Button, Box, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';


const LogIn = () => {

    const authSlice = useSelector((state: RootState) => state.auth)
    const dispatch: AppDispatch = useDispatch();
    const theme = useTheme()
    const location = useLocation();
    const navigate = useNavigate();

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [disabled, setDisabled] = useState(false)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [infoMessage, setInfoMessage] = useState<string | null>(null)

    useEffect(() =>{
        setDisabled(email === "" || email === null || password === "" || password === null)
    }, [email, password])

    const handleLogin = async () => {
        resetMessages()

        signInWithEmailAndPassword(auth, email, password).then((userCreds) => {
            userCreds.user.getIdToken().then((token) => {
               dispatch(login(token))
            })
        }).catch((err) => {
            const errorCode = err.code;
            setErrorMessage(errorCode)
        })
    }

    const handleForgotPassword = () => {
        resetMessages()
        sendPasswordResetEmail(auth, email).then(() => {
            setInfoMessage("A password reset email has been sent, please check your inbox to reset your password")
        }).catch((err) => {
            console.error(err)
            setErrorMessage("Error sending reset password email, please try again later")
        })
    }

    const resetMessages = () => {
        setErrorMessage(null)
        setInfoMessage(null)
    }

    useEffect(() => {
        if(authSlice.isAuthenticated){
            navigate({
                pathname: '/',
                search: location.search
            });
        }
    }, [authSlice.isAuthenticated])

    return (
        <div className='login-wrapper'>
            <Box sx={{backgroundColor: theme.palette.background.default}} className='login-form'>
                <h2 className='login-title'>Login!</h2>
                <TextField
                    className='login-input' 
                    value={email}
                    label="Email"
                    placeholder='example@example.com'
                    onChange={(e) => setEmail(e.target.value)}
                />
                <TextField 
                    className='login-input'
                    value={password}
                    label="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    type='password'
                />
                <Button 
                    className='login-button'
                    variant="contained"
                    onClick={handleLogin}
                    disabled={disabled}
                    sx={{backgroundColor: theme.palette.info.main}}
                >
                    Login
                </Button>

                <Button 
                    variant='text'
                    className='login-button'
                    sx={{color: theme.palette.info.main}}
                    disabled={email === "" || email === null} 
                    onClick={handleForgotPassword}
                >
                    Forgot Password
                </Button>
                {errorMessage && <span className='login-error'>{errorMessage}</span>}
                {infoMessage && <span className='login-info'>{infoMessage}</span>}
            </Box>
        </div>
    )
}

export default LogIn